import { IconType } from 'components/Icon/constants';
import { AssetAlignmentType } from 'const';
import { intlGet } from 'utils/intlGet';

export const TEXT_VERTICAL_ALIGNMENTS = [
  {
    type: AssetAlignmentType.TOP,
    hint: intlGet('TextVerticalAlignment.Hint', 'Top'),
    style: { justifyContent: 'flex-start' },
    icon: IconType.TEXT_TOP,
  },
  {
    type: AssetAlignmentType.VERTICAL_CENTER,
    hint: intlGet('TextVerticalAlignment.Hint', 'Middle'),
    style: { justifyContent: 'center' },
    icon: IconType.TEXT_CENTER,
  },
  {
    type: AssetAlignmentType.BOTTOM,
    hint: intlGet('TextVerticalAlignment.Hint', 'Bottom'),
    style: { justifyContent: 'flex-end' },
    icon: IconType.TEXT_BOTTOM,
  },
];
